import React from 'react'

import { LntFormGroup, LntFormItem, LntSelect } from '@app/components/base'

import { FILTERS_PLACEHOLDERS } from '@app/constants/filters'
import { CATALOG_KEY } from '@app/constants/queryKeys'

import {
  getCategories,
  getCommodityGroups,
  getPurchasingGroups,
  getSubcategories,
  getTrends
} from '@app/api/routes/catalog'

import { getFilterFromEntitiesToLabelsIds } from '@app/utils/entitiesAdapters'

import styles from '../styles.module.scss'

import type { TreeLentaShopProps } from './types'

export const TreeShopGroup: React.FC<TreeLentaShopProps> = ({ dataSource, disabled }) => {
  return (
    <LntFormGroup label='Дерево Ленты'>
      <div className={ styles.productCardForm__groupWrapper }>
        <LntFormItem
          className={ styles.productCardForm__item }
          name='trendId'
          defaultValue={ dataSource?.trend?.id }
        >
          <LntSelect
            disabled={ disabled }
            placeholder={ FILTERS_PLACEHOLDERS.trendsFilter }
            querySelect={ {
              queryKey: [CATALOG_KEY.trendsItems],
              queryFn: getTrends,
              select: getFilterFromEntitiesToLabelsIds
            } }
          />
        </LntFormItem>

        <LntFormItem
          className={ styles.productCardForm__item }
          name='purchasingGroupId'
          defaultValue={ dataSource?.purchasingGroup?.id }
        >
          <LntSelect
            disabled={ disabled }
            placeholder={ FILTERS_PLACEHOLDERS.purchasingGroupsFilter }
            querySelect={ {
              queryKey: [CATALOG_KEY.purchasingGroupsItems],
              queryFn: getPurchasingGroups,
              select: getFilterFromEntitiesToLabelsIds
            } }
          />
        </LntFormItem>

        <LntFormItem
          className={ styles.productCardForm__item }
          name='commodityGroupId'
          defaultValue={ dataSource?.commodityGroup?.id }
        >
          <LntSelect
            disabled={ disabled }
            placeholder={ FILTERS_PLACEHOLDERS.commodityGroupsFilter }
            querySelect={ {
              queryKey: [CATALOG_KEY.commodityGroupsItems],
              queryFn: getCommodityGroups,
              select: getFilterFromEntitiesToLabelsIds
            } }
          />
        </LntFormItem>

        <LntFormItem
          className={ styles.productCardForm__item }
          name='categoryId'
          defaultValue={ dataSource?.category?.id }
        >
          <LntSelect
            disabled={ disabled }
            className={ styles.cardItem }
            placeholder={ FILTERS_PLACEHOLDERS.categoriesFilter }
            querySelect={ {
              queryKey: [CATALOG_KEY.categoriesItems],
              queryFn: getCategories,
              select: getFilterFromEntitiesToLabelsIds
            } }
          />
        </LntFormItem>

        <LntFormItem
          className={ styles.productCardForm__item }
          name='subcategoryId'
          defaultValue={ dataSource?.subcategory?.id }
        >
          <LntSelect
            disabled={ disabled }
            placeholder={ FILTERS_PLACEHOLDERS.subcategoriesFilter }
            querySelect={ {
              queryKey: [CATALOG_KEY.subcategoriesItems],
              queryFn: getSubcategories,
              select: getFilterFromEntitiesToLabelsIds
            } }
          />
        </LntFormItem>
      </div>
    </LntFormGroup>
  )
}
